import React from "react";
import { Modal, Button } from "react-bootstrap";
import style from "./history.module.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import moment from "moment";
import { formatNumberWithCommasAndDecimal } from "../../helper";
import "./modalStyles.css";
import QRCode from "react-qr-code";
import { WEB_SITE_URL } from "../../../configuration/apiconfig";

const TransactionlistModal = (props) => {
  console.log("===qr TransactionlistModal", props?.qrData, props);
  const { currentTheme } = useSelector((state) => state.Theme);
  const Currency = useSelector((state) => state.curr);
  const { t } = useTranslation();
  if (props.type === "qr") {
    console.log(props.qrData, "props on modal");
    if (props.qrData) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Modal
            show={props.show}
            onHide={props.handleClose}
            contentClassName={`${
              currentTheme == "theme-dark"
                ? `${style.dark_mode_modalContent}`
                : `${style.modalContent}`
            }`}
            size="lg"
          >
            <Modal.Header
              closeButton
              className={`${
                currentTheme == "theme-dark"
                  ? `${style.dark_mode_modalHeader}`
                  : `${style.modalHeader}`
              }`}
            ></Modal.Header>
            <Modal.Body
              style={{
                background: currentTheme === "theme-dark" ? "" : "#fff",
                maxWidth: "1000px !important",
                width: "100%",
                overflow: "scroll",
              }}
            >
              <div className={`${style.invoiceBody}`}>
                <div className={`${style.printButton}`}>
                  <div style={{ display: "none" }}></div>
                </div>
                <Table responsive borderless width="900" height="100">
                  <tbody>
                    <tr>
                      <td colSpan="2">
                        <TableContainer style={{ marginTop: 12 }}>
                          <Table style={{ border: "none" }}>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <b>QR CODE</b>
                                </TableCell>
                                <TableCell>
                                  <b>TICKET NUMBER</b>
                                </TableCell>
                                <TableCell>
                                  <b>TRANSACTION NO.</b>
                                </TableCell>
                                <TableCell>
                                  <b>STATUS</b>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            {props.qrData.status &&
                              Array.isArray(props.qrData.data.result) && // Ensure result is an array
                              props.qrData.data.result.length > 0 && (
                                <TableBody>
                                  {" "}
                                  {/* Move TableBody outside of .map() */}
                                  {props.qrData.data.result.map(
                                    (item, index) => {
                                      return (
                                        <TableRow key={index}>
                                          {" "}
                                          {/* Add a unique key prop */}
                                          <TableCell>
                                            <div
                                              style={{
                                                height: "auto",
                                                margin: "0 auto",
                                                maxWidth: 64,
                                                width: "100%",
                                              }}
                                            >
                                              <QRCode
                                                size={300}
                                                style={{
                                                  height: "auto",
                                                  maxWidth: "100%",
                                                  width: "100%",
                                                }}
                                                value={item.ticket_number}
                                                viewBox={`0 0 256 256`}
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell>
                                            {item.ticket_number}
                                          </TableCell>
                                          <TableCell>
                                            {item.order_id_with_prefix}
                                          </TableCell>
                                          <TableCell>{item.status}</TableCell>
                                        </TableRow>
                                      );
                                    }
                                  )}
                                </TableBody>
                              )}
                          </Table>
                        </TableContainer>
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="default" onClick={props.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Modal
            show={props.show}
            onHide={props.handleClose}
            contentClassName={`${
              currentTheme == "theme-dark"
                ? `${style.dark_mode_modalContent}`
                : `${style.modalContent}`
            }`}
            size="lg"
          >
            <Modal.Header
              closeButton
              className={`${
                currentTheme == "theme-dark"
                  ? `${style.dark_mode_modalHeader}`
                  : `${style.modalHeader}`
              }`}
            ></Modal.Header>
            <Modal.Body
              style={{
                background: currentTheme === "theme-dark" ? "" : "#fff",
                maxWidth: "1000px !important",
                width: "100%",
                overflow: "scroll",
              }}
            >
              <div className={`${style.invoiceBody}`}>
                <div className={`${style.printButton}`}>
                  <div style={{ display: "none" }}></div>
                </div>
                <Table responsive borderless width="900" height="100">
                  <tbody>
                    <tr>
                      <td colSpan="2">
                        <TableContainer style={{ marginTop: 12 }}>
                          <Table style={{ border: "none" }}>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <b>QR CODE</b>
                                </TableCell>
                                <TableCell>
                                  <b>TICKET NUMBER</b>
                                </TableCell>
                                <TableCell>
                                  <b>TRANSACTION NO.</b>
                                </TableCell>
                                <TableCell>
                                  <b>STATUS</b>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                          </Table>
                        </TableContainer>
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="default" onClick={props.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    }
  } else {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Modal
          show={props.show}
          // dialogClassName="modal-fullscreen"
          onHide={props.handleClose}
          contentClassName={`${
            currentTheme == "theme-dark"
              ? `${style.dark_mode_modalContent}`
              : `${style.modalContent}`
          }`}
          size="lg"
          // centered
        >
          <Modal.Header
            closeButton
            className={`${
              currentTheme == "theme-dark"
                ? `${style.dark_mode_modalHeader}`
                : `${style.modalHeader}`
            }`}
          ></Modal.Header>
          <Modal.Body
            style={{
              background: currentTheme === "theme-dark" ? "" : "#fff",
              maxWidth: "1000px !important",
              width: "100%",
              overflow: "scroll",
            }}
          >
            <div className={`${style.invoiceBody}`}>
              <div className={`${style.printButton}`}>
                <div style={{ display: "none" }}></div>
              </div>
              <Table responsive borderless width="900" height="100">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ textAlign: "left" }}>
                    <h6>
                      <b>SHIP TO</b>
                    </h6>
                    <p>
                      <b> {props?.data?.data?.name}</b>
                    </p>
                    <p>
                      <b>ADDRESS:</b> {props?.data?.data?.address}
                    </p>
                    <p>
                      <b>DELIVERY MODE:</b> {props?.data?.data?.deliveryMode}
                    </p>
                  </div>
                  <div style={{ width: "50%", textAlign: "right" }}>
                    <h3>Transaction No: {props?.data?.data?.transaction_no}</h3>
                    <p style={{ marginTop: 8 }}>
                      Transaction Date:
                      {/* {moment(props?.data?.data?.date).format(
                        "DD-MM-YYYY HH:mm:ss"
                      )} */}
                      {moment
                        .utc(props?.data?.data?.date)
                        .subtract(8, "hours")
                        .tz("Asia/Manila")
                        .format("MM/DD/YYYY h:mm:ss A")}
                    </p>
                  </div>
                </div>
                <tbody>
                  <tr>
                    <td colSpan="2">
                      <TableContainer style={{ marginTop: 12 }}>
                        <Table style={{ border: "none" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <b>{t("profile.product")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("Common.sequence")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("Common.activationcode")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("Common.securitycode")}</b>
                              </TableCell>
                              <TableCell>
                                <b>Expiration Date</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("Common.status")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("Common.quantity")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("Common.unitprice")}</b>
                              </TableCell>
                              <TableCell>
                                <b>{t("Common.amount")}</b>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {props?.data?.data?.codeResult &&
                              props?.data.data?.codeResult.map(
                                (product, index) => (
                                  <TableRow key={index}>
                                    <TableCell>{product.product}</TableCell>
                                    <TableCell>{product.sequence}</TableCell>
                                    <TableCell>{product.access_code}</TableCell>
                                    <TableCell>
                                      {product.security_code}
                                    </TableCell>
                                    <TableCell>
                                      {product.expiry
                                        ? moment
                                            .utc(product.expiry)
                                            .subtract(8, "hours")
                                            .tz("Asia/Manila")
                                            .format("MM/DD/YYYY h:mm:ss A")
                                        : ""}
                                    </TableCell>
                                    <TableCell
                                      style={
                                        product.status === "Open"
                                          ? { color: "green" }
                                          : { color: "red" }
                                      }
                                    >
                                      {product.status}
                                    </TableCell>
                                    <TableCell>{product.quantity}</TableCell>
                                    <TableCell>
                                      <div style={{ display: "flex" }}>
                                        <div>{Currency.currentCurr} </div>
                                        <div>
                                          {formatNumberWithCommasAndDecimal(
                                            product.unit_price * Currency.value,
                                            Currency.precision
                                          )}
                                        </div>
                                      </div>

                                      {/* {product.unit_price} */}
                                    </TableCell>

                                    {/* <TableCell>{product.amount}</TableCell> */}
                                    <TableCell>
                                      {/* {Currency.currentCurr}{" "}
                                  {CurrencyDecimalFormat(
                                    product.amount * Currency.value,
                                    Currency.precision
                                  )} */}
                                      {/* {product.amount} */}
                                      <div style={{ display: "flex" }}>
                                        <div>{Currency.currentCurr} </div>
                                        <div>
                                          {formatNumberWithCommasAndDecimal(
                                            product.amount * Currency.value,
                                            Currency.precision
                                          )}
                                        </div>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                )
                              )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <table
                        border="0"
                        width="50%"
                        height="100"
                        align="right"
                        className={style.tableBottom}
                      >
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Cart Totals</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            <b>Cart Subtotal</b>
                          </TableCell>
                          {/* <TableCell>{props?.data?.data?.sub_total}</TableCell> */}
                          {/* <TableCell>{props?.data?.data?.sub_total ?  {Currency.currentCurr}{" "}
                                  {CurrencyDecimalFormat(
                                    props.data.data.sub_total * Currency.value,
                                    Currency.precision
                                  )}:0}</TableCell> */}
                          <TableCell>
                            {props.data?.data?.sub_total
                              ? Currency.currentCurr +
                                " " +
                                formatNumberWithCommasAndDecimal(
                                  props.data.data.sub_total * Currency.value,
                                  Currency.precision
                                )
                              : Currency.currentCurr + " 0.00"}
                            {/* {props?.data?.data?.sub_total} */}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Convenience Fee</b>
                          </TableCell>
                          {/* <TableCell>{props?.data?.data?.sub_total}</TableCell> */}
                          {/* <TableCell>{props?.data?.data?.sub_total ?  {Currency.currentCurr}{" "}
                                  {CurrencyDecimalFormat(
                                    props.data.data.sub_total * Currency.value,
                                    Currency.precision
                                  )}:0}</TableCell> */}
                          <TableCell>
                            {props.data?.data?.convenience
                              ? Currency.currentCurr +
                                " " +
                                formatNumberWithCommasAndDecimal(
                                  props.data.data.convenience * Currency.value,
                                  Currency.precision
                                )
                              : Currency.currentCurr + " 0.00"}
                            {/* {props?.data?.data?.sub_total} */}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Shipping and handling</b>
                          </TableCell>
                          <TableCell>
                            {/* {props?.data?.data?.shipping} */}
                            {props.data?.data?.shipping
                              ? Currency.currentCurr +
                                " " +
                                formatNumberWithCommasAndDecimal(
                                  props.data.data.shipping * Currency.value,
                                  Currency.precision
                                )
                              : Currency.currentCurr + " 0.00"}
                          </TableCell>
                        </TableRow>
                        <TableRow style={{ backgroundColor: "lightgray" }}>
                          <TableCell>
                            <b>Discount</b>
                          </TableCell>
                          <TableCell>
                            {/* {props?.data?.data?.discount} */}
                            {props.data?.data?.discount
                              ? Currency.currentCurr +
                                " " +
                                formatNumberWithCommasAndDecimal(
                                  props.data.data.discount * Currency.value,
                                  Currency.precision
                                )
                              : Currency.currentCurr + " 0.00"}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Order Total</b>
                          </TableCell>
                          <TableCell>
                            {/* {props?.data?.data?.order_total} */}
                            {props.data?.data?.order_total
                              ? Currency.currentCurr +
                                " " +
                                formatNumberWithCommasAndDecimal(
                                  props.data.data.order_total * Currency.value,
                                  Currency.precision
                                )
                              : Currency.currentCurr + " 0.00"}
                          </TableCell>
                        </TableRow>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </Table>
              {/* </div> */}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="default" onClick={props.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
};

export default TransactionlistModal;
